import {
    Button,
    Tag,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    Checkbox,
    Textarea,
    extendTheme,
    ChakraProvider,
    Box
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import Swal from "sweetalert2";
import MotivoSituacaoService from "../../../main/services/MotivoSituacaoService";
import { useHistory } from 'react-router-dom';
import LoadingSpinner from '../../components/LoadingSpinner';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { motivoFunc } from '../../../helpers/Funcionalidades';
import SemRegistros from '../../components/SemRegistros';
import { Group } from '../Criancas/Group';

const AlterarVigenciaMotivoSituacao = (props) => {

    document.title = 'MCA - Motivo de Situação - Alterar Vigência'

    let history = useHistory();

    const { roleKeycloack } = useAuthProvider();
    const _IsMounted = useRef(false);
    const [justificativaCount, setJustificativaCount] = useState(0);
    const [motivoSituacao, setMotivoSituacao] = useState({
        descricao: "",
        tipoSituacaoId: "",
        riscoVida: [],
        extincaoPoderFamiliar: [],
        conceito: "",
        justificativaAntiga: ""
    });
    const [loading, setLoading] = useState(true);

    const theme = extendTheme({
        components: {
            Checkbox: {
                baseStyle: {
                    control: {
                        bg: "#dbdbdb",
                        borderColor: 'rgba(102,102,102,0.7)',
                        borderWidth: '1px',
                        _checked: {
                            bg: "#dbdbdb",
                            color: '#000',
                            border: '1px solid #666',
                            opacity: '0.7 !important'
                        },
                        _readonly: {
                            bg: "#dbdbdb",
                            color: '#000',
                            border: '1px solid #666',
                            opacity: '0.7 !important'
                        }
                    }
                }
            }
        }
    });

    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function fetchData() {
        MotivoSituacaoService.getMotivoSituacao(props.match.params.id)
            .then(res => {
                const {
                    riscoVida,
                    extincaoPoderFamiliar,
                    tipoSituacao,
                    justificativa,
                    ...resto
                } = res.data;
                setMotivoSituacao({
                    riscoVida: riscoVida === "S" ? ["Possui"] : [],
                    extincaoPoderFamiliar: extincaoPoderFamiliar === "S" ? ["Possui"] : [],
                    tipoSituacaoId:
                        tipoSituacao.id === 1 ? "Acolhido" :
                            tipoSituacao.id === 2 ? "Desligado" : "",
                    justificativaAntiga: justificativa ? justificativa : "" || "",
                    ...resto
                });
                setLoading(false);
            }).catch((err) => {
                Swal.fire({
                    title: 'Erro!',
                    'text': err.response.data.message ? err.response.data.message : "Houve um erro na requisição",
                    icon: 'error',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: '#169499'
                }).then(() => {
                    window.location.to = "/motivo-situacao/lista";
                });
            })
    }

    return roleKeycloack && roleKeycloack.includes(motivoSituacao.dataFim ? motivoFunc.motivoReativar : motivoFunc.motivoInativar) ? (
        !loading
            ?
            <Flex
                pt={"20px"}
                px={["5px", "30px"]}
                h="100%"
                flexDir="column"
                w="100%"
                maxW="2000px"
                overflow="auto"
                pb={["10px", "20px"]}
            >
                <Flex
                    flexDir="row"
                    justifyContent="space-between"
                >

                    <Heading fontSize={'large'}>
                        {motivoSituacao.dataFim ? "Reativar Motivo de Situação" : "Inativar Motivo de Situação"}
                    </Heading>
                    <Button onClick={history.goBack} colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Flex>
                <Formik
                    enableReinitialize
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={motivoSituacao}
                    onSubmit={(values, { setFieldError, setSubmitting }) => {
                        let updated;
                        const {
                            justificativa
                        } = values;

                        const valuesToSend = {
                            justificativa: justificativa ? justificativa : "",
                        }

                        MotivoSituacaoService.getMotivoSituacao(props.match.params.id)
                            .then(res => {
                                updated = res.data
                                const acaoUp = updated.dataFim ? "reativar" : "inativar";
                                if (acaoUp !== (motivoSituacao.dataFim ? "reativar" : "inativar")) {
                                    Swal.fire({
                                        title: 'Atenção',
                                        text: updated.dataFim ?
                                            "Este registro já está inativo. Deseja reativá-lo?" :
                                            "Este registro está ativo. Deseja inativá-lo?",
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#169499',
                                        cancelButtonColor: '#169499',
                                        confirmButtonText: updated.dataFim ?
                                            "Sim, quero reativar!" :
                                            "Sim, quero inativar!",
                                        cancelButtonText: 'Cancelar'
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            fetchData();
                                        }
                                    })
                                    setSubmitting(false);
                                } else {
                                    if (motivoSituacao.dataFim) {
                                        MotivoSituacaoService.reativarMotivoSituacao(motivoSituacao.id, valuesToSend)
                                            .then((res) => {
                                                Swal.fire({
                                                    title: 'Sucesso!',
                                                    'text': 'Registro reativado com sucesso!',
                                                    icon: 'success',
                                                    confirmButtonText: 'Continuar',
                                                    confirmButtonColor: '#169499'
                                                }).then(function () {
                                                    history.push("/motivo-situacao/lista");
                                                });

                                            }).catch((error) => {
                                                setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                                                setSubmitting(false);
                                            })
                                    } else {
                                        MotivoSituacaoService.inativarMotivoSituacao(motivoSituacao.id, valuesToSend)
                                            .then((res) => {
                                                Swal.fire({
                                                    title: 'Sucesso!',
                                                    'text': 'Registro inativado com sucesso!',
                                                    icon: 'success',
                                                    confirmButtonText: 'Continuar',
                                                    confirmButtonColor: '#169499'
                                                }).then(function () {
                                                    history.push("/motivo-situacao/lista");
                                                });
                                            }).catch((error) => {
                                                setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                                                setSubmitting(false);
                                            })
                                    }
                                    setSubmitting(false);
                                }
                            }).catch((error) => {
                                setSubmitting(false);
                            })

                    }}
                >
                    {(props) => (
                        <Flex
                            flexDir={"column"}
                            mt={"40px"}
                            w={"100%"}>
                            <Form>
                                <Flex
                                    flexDir={"column"}>
                                    <Group bgColor="#fff" title="" py="12px" >
                                        <Box width={{ lg: '50%' }}>
                                            <Field name="tipoSituacaoId">
                                                {({ field, form }) => (
                                                    <Flex flexDir="column" mb={5}>
                                                        <FormControl isInvalid={form.errors.tipoSituacaoId && form.touched.tipoSituacaoId}>
                                                            <FormLabel htmlFor="tipoSituacaoId">Tipo de Motivo de Situação</FormLabel>
                                                            <Input
                                                                isDisabled
                                                                focusBorderColor={"false"}
                                                                backgroundColor={"#D7D8DE"}
                                                                id="tipoSituacaoId"
                                                                {...field}
                                                                placeholder="Tipo de Motivo de Situação"
                                                                h="42px"
                                                            />
                                                            <FormErrorMessage>{form.errors.tipoSituacaoId}</FormErrorMessage>
                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                            <Field name="descricao">
                                                {({ field, form }) => (
                                                    <Flex flexDir="column" mb={5}>
                                                        <FormControl isInvalid={form.errors.descricao && form.touched.descricao}>
                                                            <FormLabel htmlFor="descricao">Descrição</FormLabel>
                                                            <Input
                                                                isDisabled
                                                                focusBorderColor={"false"}
                                                                backgroundColor={"#D7D8DE"}
                                                                id="descricao"
                                                                {...field}
                                                                placeholder="Informe a Descrição do Motivo de Situação"
                                                                h="42px"
                                                            />
                                                            <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                            <Field name="conceito">
                                                {({ field, form }) => (
                                                    <Flex flexDir="column">
                                                        <FormControl isInvalid={form.errors.conceito && form.touched.conceito}>
                                                            <FormLabel htmlFor="descricao">Conceito</FormLabel>
                                                            <Textarea
                                                                minH={150}
                                                                isDisabled
                                                                focusBorderColor={"false"}
                                                                backgroundColor={"#D7D8DE"}
                                                                id="conceito"
                                                                {...field}
                                                                placeholder=""
                                                            />
                                                            <FormErrorMessage>{form.errors.conceito}</FormErrorMessage>
                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                            <Flex mt={5} flexDirection="column">
                                                <Field name="riscoVida">
                                                    {({ field, form }) => (
                                                        <FormControl
                                                            id="riscoVida"
                                                            width="max-content"
                                                        >
                                                            <ChakraProvider theme={theme}>
                                                                <Checkbox
                                                                    {...field}
                                                                    value="Possui"
                                                                    name="riscoVida"
                                                                    id="riscoVida"
                                                                    whiteSpace="nowrap"
                                                                    isReadOnly
                                                                    defaultChecked={
                                                                        props.values.riscoVida
                                                                            ?
                                                                            props.values.riscoVida.includes("Possui")
                                                                            :
                                                                            false
                                                                    }
                                                                >
                                                                    Risco de Vida
                                                                </Checkbox>
                                                            </ChakraProvider>
                                                            <FormErrorMessage>{form.errors.riscoVida}</FormErrorMessage>
                                                        </FormControl>
                                                    )}
                                                </Field>
                                                <Field name="extincaoPoderFamiliar">
                                                    {({ field, form }) => (
                                                        <FormControl
                                                            id="extincaoPoderFamiliar"
                                                            width="max-content"
                                                        >
                                                            <ChakraProvider theme={theme}>
                                                                <Checkbox
                                                                    {...field}
                                                                    value="Possui"
                                                                    name="extincaoPoderFamiliar"
                                                                    id="extincaoPoderFamiliar"
                                                                    whiteSpace="nowrap"
                                                                    isReadOnly
                                                                    defaultChecked={
                                                                        props.values.extincaoPoderFamiliar
                                                                            ?
                                                                            props.values.extincaoPoderFamiliar.includes("Possui")
                                                                            :
                                                                            false
                                                                    }
                                                                >
                                                                    Houve Extinção do Poder Familiar?
                                                                </Checkbox>
                                                            </ChakraProvider>
                                                            <FormErrorMessage>{form.errors.extincaoPoderFamiliar}</FormErrorMessage>
                                                        </FormControl>
                                                    )}
                                                </Field>
                                            </Flex>
                                            {motivoSituacao.dataFim ? (
                                                <Field name="justificativaAntiga">
                                                    {({ field, form }) => (
                                                        <Flex flexDir="column" mt={5}>
                                                            <FormControl isInvalid={form.errors.justificatiavaAntiga && form.touched.justificatiavaAntiga}>
                                                                <FormLabel htmlFor="justificativaAntiga">Justificativa de Inativação</FormLabel>
                                                                <Textarea
                                                                    minH={150}
                                                                    w="100%"
                                                                    cursor={"default"}
                                                                    focusBorderColor={"none"}
                                                                    isDisabled
                                                                    backgroundColor={"#D7D8DE"}
                                                                    id="justificativaAntiga"
                                                                    {...field}
                                                                    placeholder="Justificativa da Ativação/Inativação" />
                                                            </FormControl>
                                                        </Flex>
                                                    )}
                                                </Field>
                                            ) : (
                                                <></>
                                            )}
                                            <Field name="justificativa">
                                                {({ field, form }) => (
                                                    <Flex flexDir="column" mt={5}>
                                                        <FormControl isInvalid={form.errors.justificativa && form.touched.justificativa}>
                                                            <FormLabel htmlFor="justificativa">Justificativa de {motivoSituacao.dataFim ? "Reativação" : "Inativação"}</FormLabel>
                                                            <Textarea
                                                                autoFocus
                                                                w="100%"
                                                                backgroundColor={"white"}
                                                                id="justificativa"
                                                                {...field}
                                                                placeholder="Justificativa da Ativação/Inativação"
                                                                maxLength={4000}
                                                                onChange={(e) => {
                                                                    setJustificativaCount(e.target.value.length);
                                                                    form.setFieldValue(field.name, e.target.value);
                                                                }}
                                                            />
                                                            <FormErrorMessage>{form.errors.justificativa}</FormErrorMessage>
                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                            <Flex flexDirection="row-reverse">
                                                <Tag maxW="max-content">{`${justificativaCount}/4000`}</Tag>
                                            </Flex>
                                        </Box>
                                    </Group>

                                </Flex>

                                <Flex mt={2} justifyContent="space-between">
                                    <Flex></Flex>
                                    <Button
                                        mt={4}
                                        mr={2}
                                        colorScheme={"teal"}
                                        px={14}
                                        isLoading={props.isSubmitting}
                                        type="submit"
                                        translate="no">
                                        {motivoSituacao.dataFim ? "Reativar" : "Inativar"}
                                    </Button>
                                </Flex>

                            </Form>
                        </Flex>
                    )}

                </Formik>
            </Flex>
            :
            <Flex
                w="100%"
                mt="25%"
                justifyContent="center"
            >
                <LoadingSpinner />
            </Flex>

    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    )
}
export default AlterarVigenciaMotivoSituacao;
